<template>
    <button class="btn btn-primary "
    v-if="isLoggedIn()" @click="logout" >Kijelentkezés</button>
</template>

<style scoped>
/* Button styles moved to components.css */
</style>
<script>
export default {

    methods: {
    
        isLoggedIn() {
            return this.$isLoggedIn();
        },  
        
        async logout() {
            try {
                await this.$logout();
            } catch (err) {
                this.error = err.response?.data?.message || 'Logout failed';
            }
        }

    },
};
</script>
